import React                   from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect }             from 'react-redux';
import { bindActionCreators }  from 'redux';
import queryString             from "query-string";
import * as sessionActionCreators from './actions/session'

import AppLayout               from './components/pages/layouts/AppLayout';
import LoginLayout             from './components/pages/layouts/LoginLayout';
import LandingLayout           from './components/pages/layouts/LandingLayout';
import OauthAuthorizeLayout    from './components/pages/layouts/OauthAuthorizeLayout';
import Bank                    from './components/pages/Bank';
import Application             from './components/pages/Application';
import Transaction             from './components/pages/Transaction';
import Csv                     from './components/pages/Csv';
import Account                 from './components/pages/Account';
import Tags                    from './components/pages/Tags';
import Login                   from './components/pages/Login';
import OauthAuthorize          from './components/pages/OauthAuthorize';
import ErrorOauthAuthorize     from './components/pages/ErrorOauthAuthorize';
import AgreeTermOfUse          from './components/pages/AgreeTermOfUse';
import Landing                 from './components/pages/Landing';
import Support                 from './components/pages/Support';
import AppUsage                from './components/pages/supports/AppUsage';
import TermsOfUse              from './components/pages/TermsOfUse';
import TermsOfUseAgreement     from './components/pages/TermsOfUseAgreement';
import UserSetting             from './components/pages/UserSetting';
import NotFound                from './components/pages/errors/NotFound';
import UnderMaintenance        from './components/pages/errors/UnderMaintenance';
import FiveZeroFour            from './components/pages/errors/FiveZeroFour';
import ActivateError           from './components/pages/ActivateError';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout>
      <Component {...props} />
    </Layout>
  )} />
)

const buildRoutes = () => {
  return (
    <Switch>
      {/* LandingLayout */}
      <AppRoute exact path="/" layout={LandingLayout} component={Landing} />
      <AppRoute exact path="/landing_page" layout={LandingLayout} component={Landing} />

      {/* OauthAuthorizeLayout */}
      <AppRoute exact path="/oauth/authorize" layout={OauthAuthorizeLayout} component={OauthAuthorize} />
      <AppRoute exact path="/oauth/authorize/erro" layout={OauthAuthorizeLayout} component={ErrorOauthAuthorize} />
      <AppRoute exact path="/agreement" layout={OauthAuthorizeLayout} component={AgreeTermOfUse} />
      <AppRoute exact path="/activate-error" layout={LoginLayout} component={ActivateError} />

      {/* AppLayout */}
      <AppRoute exact path="/bank" layout={AppLayout} component={Bank} />
      <AppRoute exact path="/bank/:account_identifier/:type" layout={AppLayout} component={Bank} />
      <AppRoute exact path="/bank/:account_identifier" layout={AppLayout} component={Bank} />
      <AppRoute exact path="/application" layout={AppLayout} component={Application} />
      <AppRoute exact path="/transaction" layout={AppLayout} component={Transaction} />
      <AppRoute exact path="/csv" layout={AppLayout} component={Csv} />
      <AppRoute exact path="/account" layout={AppLayout} component={Account} />
      <AppRoute exact path="/tags" layout={AppLayout} component={Tags} />
      <AppRoute exact path="/support" layout={AppLayout} component={Support} />
      <AppRoute exact path="/support-app-usage" layout={AppLayout} component={AppUsage} />
      <AppRoute exact path="/terms-of-use" layout={AppLayout} component={TermsOfUse} />
      <AppRoute exact path="/user-setting" layout={AppLayout} component={UserSetting} />

      {/* LoginLayout */}
      <AppRoute exact path="/login" layout={LoginLayout} component={Login} />
      <AppRoute exact path="/terms-of-use-agreement" layout={LoginLayout} component={TermsOfUseAgreement} />
      <AppRoute exact path="/under-maintenance" layout={LoginLayout} component={UnderMaintenance} />
      <AppRoute exact path="/504" layout={LoginLayout} component={FiveZeroFour} />
      <AppRoute exact path="*" layout={LoginLayout} component={NotFound} />
    </Switch>
  )
}

class RouterWrapper extends React.Component {
  constructor(props) {
    super(props)

    this.hasInitialData = this.hasInitialData.bind(this)
    this.onEnterAuthSection = this.onEnterAuthSection.bind(this)
    this.handleAfterLoaded = this.handleAfterLoaded.bind(this)
    this.checkRedirect = this.checkRedirect.bind(this)
    this.state = {
      fetching: true
    }
  }

  componentDidMount() {
    this.onEnterAuthSection(this.handleAfterLoaded)
    this.routes = buildRoutes()

  }

  handleAfterLoaded() {
    this.setState({ fetching: false })
  }

  hasInitialData() {
    const mf_authorization = JSON.parse(localStorage.getItem('mf_authorization'))
    if (mf_authorization) {
      const access_token = mf_authorization.access_token
      this.props.sessionActions.defaultSession({
        access_token: access_token,
        term_agreed: mf_authorization.term_agreed,
        isFetchingSession: false
      })
      return true
    }

    return false;
  }

  saveIndentifier(data) {
    const {account_identifier, type} = data
    if (!account_identifier || !type)
      return

    return localStorage.setItem("accountIndentifier", JSON.stringify(data))
  }

  bankUrl() {
    let url = "/bank"

    const accountIndentifier = JSON.parse(localStorage.getItem('accountIndentifier'))
    if (accountIndentifier) {
      const { account_identifier, type } = accountIndentifier
      url = `${url}/${account_identifier}/${type}`
      localStorage.removeItem('accountIndentifier');
    }

    return url
  }

  refererUrl(pathname) {
    if (pathname === '/' || pathname === '/landing_page' || pathname === '/login' || pathname === '/under-maintenance')
      return

    localStorage.setItem("refererUrl", pathname)
  }

  checkRedirect() {
    const { location, history } = this.props
    const oauth_authorize = JSON.parse(localStorage.getItem('oauth_authorize'))
    const mf_authorization = JSON.parse(localStorage.getItem('mf_authorization'))

    if (mf_authorization && !mf_authorization.term_agreed && location.pathname !== '/agreement') {
      history.replace("/agreement")
      return
    }

    if (oauth_authorize && oauth_authorize.client_id && oauth_authorize.redirect_uri) {
      // has `oauth_authorize` in cache
      history.replace("/oauth/authorize")
      return
    } else if (localStorage.getItem("refererUrl")) {
      if (localStorage.getItem("refererUrl") !== "/") {
        history.replace(localStorage.getItem("refererUrl"))
      }

      localStorage.removeItem("refererUrl")
      return
    }

    if (location.pathname === '/') {
      history.replace(this.bankUrl())
    }
  }

  onEnterAuthSection(callback) {
    const { location, history, match } = this.props

    // store `oauth_authorize` data
    const query = queryString.parse(location.search);
    if (query && query.client_id && query.redirect_uri) {
      // remove old data
      localStorage.removeItem('oauth_authorize');
      // add new data
      localStorage.setItem('oauth_authorize', JSON.stringify(query))
    }

    if (!this.hasInitialData()) {
      this.saveIndentifier(match.params)
      if (query.code) {
        // in case login on MFID
        history.replace("/")
        var _this = this
        const verifier = window.sessionStorage.getItem("code_verifier")
        return Promise.all([this.props.sessionActions.login({ mf_token: query.code, code_verifier: verifier })])
          .then(res => {
            _this.checkRedirect()
            callback()
          }).catch((error) => {
            if (error.status !== 500) {
              window.location.href = "/activate-error"
            } else {
              window.location.href = "/login"
            }
          });
      } else {
        // NO login
        if (location.pathname !== '/' && location.pathname !== '/landing_page' && location.pathname !== '/agreement'
          && location.pathname !== '/under-maintenance' && location.pathname !== '/activate-error') {
          this.refererUrl(location.pathname)
          history.replace("/login")
        }
      }
    } else {
      this.checkRedirect()
    }
    callback()
  }

  render() {
    return (
      <div className='router-wrapper'>
        {!this.state.fetching && this.routes}
      </div>
    )
  }
}

RouterWrapper.displayName = 'RouterWrapper';

function mapStateToProps(state) {
  const access_token = state.session && state.session.get('access_token')
  return {
    token: access_token && access_token.token
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    sessionActions: bindActionCreators(sessionActionCreators, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RouterWrapper)
